export const mutations = {
	SEARCH(state,itemArray){
		if(itemArray.CODE == 200){
			state.item = [];
			state.alreadyClick = false;
			state.showlist=true;
			for(var i = 0 ; i<itemArray.ENTERPRISES.length; i++){
	            if(i<6){
	            	var entName = itemArray.ENTERPRISES[i].ENTNAME;
					var entType = itemArray.ENTERPRISES[i].ENTTYPE;
					var entStatusCode = itemArray.ENTERPRISES[i].ENTSTATUSCODE;
					var entStatus = itemArray.ENTERPRISES[i].ENTSTATUS;
	                state.item.push({
	                	entName,
	                	entType,
						entStatusCode,
						entStatus
	                })
	            }
	        }
		}
	},
	INDIVIDUALSEARCH(state,itemArray){
		if(itemArray.CODE == 200){
			state.item = [];
			state.alreadyClick = false;
			state.showlist=true;
			for(var i = 0 ; i<itemArray.ENTERPRISES.length; i++){
	            if(i<6){
	            	var entName = itemArray.ENTERPRISES[i].ENTNAME;
	            	var pripid = itemArray.ENTERPRISES[i].ID;
					var legelName = itemArray.ENTERPRISES[i].NAME;
					var entStatusCode = itemArray.ENTERPRISES[i].ENTSTATUSCODE;
					var entStatus = itemArray.ENTERPRISES[i].ENTSTATUS;
	                state.item.push({
	                	entName,
	                	pripid,
	                	legelName,
						entStatusCode,
						entStatus
	                })
	            }
	        }
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/mutations.js